import { Component, forwardRef, Input } from '@angular/core';
import { TenantItemDto } from '@artemis-software/wr-api';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'wr-fixed-tenant-select',
  templateUrl: './fixed-tenant-select.component.html',
  styleUrls: ['./fixed-tenant-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FixedTenantSelectComponent),
      multi: true,
    },
  ],
})
export class FixedTenantSelectComponent extends AbstractFormControl<TenantItemDto> {
  @Input()
  tenants = [] as TenantItemDto[];

  @Input()
  showEmptyOption: boolean = false;

  compareTenants(tenant1: TenantItemDto | undefined, tenant2: TenantItemDto | undefined): boolean {
    return tenant1?.id === tenant2?.id;
  }
}
